import { CircleAlert } from "lucide-react";
import { Alert, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import Spinner from "./Spinner";

interface Props {
  open: boolean;
  onOpenChange(open: boolean): void;
  title: string;
  description?: React.ReactNode;
  submitLabel: string;
  submitting?: boolean;
  canSubmit?: boolean;
  error?: string | null;
  onSubmit(): void;
  children: React.ReactNode;
}

// A dialog around one form: Enter submits, the dialog cannot close while submitting.
const FormDialog: React.FC<Props> = ({
  open,
  onOpenChange,
  title,
  description,
  submitLabel,
  submitting = false,
  canSubmit = true,
  error,
  onSubmit,
  children,
}) => (
  <Dialog open={open} onOpenChange={(next) => !submitting && onOpenChange(next)}>
    <DialogContent className="sm:max-w-md">
      <form
        className="grid gap-5"
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          if (!submitting && canSubmit) onSubmit();
        }}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description ? (
            <DialogDescription>{description}</DialogDescription>
          ) : (
            <DialogDescription className="sr-only">{title}</DialogDescription>
          )}
        </DialogHeader>
        <div className="grid gap-4">{children}</div>
        {error && (
          <Alert variant="destructive">
            <CircleAlert />
            <AlertTitle>{error}</AlertTitle>
          </Alert>
        )}
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            disabled={submitting}
            onClick={() => onOpenChange(false)}
          >
            Annuleren
          </Button>
          <Button type="submit" disabled={submitting || !canSubmit}>
            {submitting && <Spinner />}
            {submitLabel}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);

export default FormDialog;
